import { useNavigate } from 'react-router-dom';
import SearchFilterSort from './SearchFilterSort';
import EventListCard from '../../../../components/Cards/EventListCard';
import NoCreatedEvent from './NoCreatedEvent';
import LoadingSpinner from '../../../../animation/LoadingSpinner';
import useMyEvents from './hooks/useMyEvents';
import '../../../../styles/user-dashboard/MyEvents.css';

export default function MyEvents() {
    const navigate = useNavigate();

    const {
        userEvents,
        loading,
        filterOptions,
        setSearchTerm,
        filteredEvents,
        setSelectedFilter
    } = useMyEvents();

    function handleNewEventCreation() {
        navigate('/event/new/event-details');
    }

    if (loading) {
        return <LoadingSpinner message="Loading your events..." />;
    }

    if (!userEvents?.data || userEvents?.data?.length === 0) {
        return <NoCreatedEvent onClick={handleNewEventCreation} />;
    }

    return (
        <div id="my-events-container">
            <div className="my-event-list-wrapper-container">
                <div className="my-event-list-sort-search-container">
                    <SearchFilterSort
                        filterOptions={filterOptions}
                        onSearchInputChange={(value) => setSearchTerm(value)}
                        onFilterChange={(value) => setSelectedFilter(value)}
                    />
                </div>

                <div className="my-event-list">
                    {filteredEvents.length === 0 ? (
                        <NoCreatedEvent
                            shouldShowButton={false}
                            title="No events found"
                            description={`The event that you are looking for is not available. Try different event name or filter options.`}
                        />
                    ) : (
                        filteredEvents.map((event) => (
                            <EventListCard
                                key={event.eventId}
                                eventId={event?.eventId}
                                slug={event?.slug}
                                name={event?.title}
                                venueName={event?.venue}
                                latitude={event?.latitude}
                                longitude={event?.longitude}
                                status={event?.status}
                                eventType={event?.event_type}
                                isPublicEvent={event?.is_private}
                                startDate={event?.start_date}
                                endDate={event?.end_date}
                                startTime={event?.start_time}
                                endTime={event?.end_time}
                                schedule={event?.schedules}
                                isPublishable={event?.is_publishable}
                                createdAt={event?.created_at}
                                updatedAt={event?.updated_at}
                                totalTickets={event?.total_tickets}
                            // eventThumbnail={event?.thumbnail}
                            />
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}